import EventBus from '@/utils/eventBus'
import logger from '@/utils/log'

let flags = {}

let handler = (function() {
  return {
    emit(event) {
      flags[event] = true
      logger.info(`[EH:EMIT] event publish`, event)
      EventBus.$emit(event)
    },
    once(callback, ...events) {
      let eventId = _.random(0, 5000)
      logger.info(`[EH:START:${eventId}]`, 'event handler', events)
      if (events.length === 0 || typeof callback !== 'function') {
        logger.info(`[EH:END:${eventId}]`, 'event handler parameter failed...')
        return
      }
      if (this.eventCalledCheck(events)) {
        logger.info(
          `[EH:END:${eventId}]`,
          'event handler Events Called...',
          events
        )
        callback()
      }
      events.forEach(event => {
        if (flags[event]) return
        EventBus.$once(event, () => {
          logger.info(
            `[EH:${eventId}]`,
            'event handler Events Recieve',
            event,
            JSON.stringify(flags)
          )
          // 모든 이벤트가 로드 되면, callback을 실행
          if (this.eventCalledCheck(events)) {
            logger.info(
              `[EH:END:${eventId}]`,
              'event handler Events All Recieved'
            )
            callback()
          }
        })
      })
    },
    eventCalledCheck(events) {
      return events.every(event => flags[event])
    }
  }
})()

export default handler
